// CSV column layout for the visit CSV. Data rows begin at row index 3
// (row 0 = outer header, row 1 = filter/date, row 2 = column headers).
export const CSV_DATA_START_ROW = 3;

export const CSV_COL = {
  ROW_ID: 0,
  ADMISSION_ID: 1,
  PATIENT_NAME: 2,
  BRANCH: 3,
  CONTRACT: 4,
  CAREGIVER: 5,
  ASSIGNMENT_ID: 6, // unused
  DATE: 7,
  ACTUAL_SCHEDULE: 8, // CSV columns are reversed: this field holds SCHEDULED hours
  VISIT_SCHEDULE: 9,  // and this one holds ACTUAL hours (see parser).
  BILLED: 10,
};

// Hours per day beyond which a scheduling error is presumed (data-entry check).
export const DAY_HOUR_CAP = 24;

// Tolerance in minutes before Late/Early or Overlap is flagged.
export const TIME_TOLERANCE_MIN = 7;
